module.exports = __webpack_public_path__ + "static/media/banner.df70dbca.png";